module.exports = __webpack_public_path__ + "static/book-reading-8ebb949269f0cdba1274904cde258634.jpg";